<script>
let id = 1000
let fromData = ''
let toData = ''
let fromParentModelChildren = ''
let nodeClicked = null

export default {
  name: 'TreeViewCategories',

  props: {
    model: Object,
    buttonsTitle: Object,
    clickFunction: Function,
    id: String,
    father: Object,
    defaultText: String,
    currentHighlight: Boolean,
    hoverColor: String,
    highlightColor: String,
    spaceLeft: String,
    styleObj: Object,
    clickRemoveFunction: {
      type: Function,
      default: null
    },
    showRemove: {
      type: Boolean,
      default: false
    }
  },

  data: function () {
    return {
      open: false,
      isClicked: false
    }
  },

  computed: {
    orderedNumbers () {
      return this.model.children.sort((a, b) => Number(a.number.replace(/\./g, '')) - Number(b.number.replace(/\./g, '')))
    },

    isFolder () {
      return this.model.children &&
        this.model.children.length
    }
  },

  template: `<div class="treeview">

              <div :id='model.id' draggable='false' @dragstart='dragStart' @dragover='dragOver' @dragenter='dragEnter' @dragleave='dragLeave' @drop='drop' @dragend='dragEnd' class='col-xs-12 col-sm-12 col-md-12 treeRow pl-0' :class="[model.mainFather ? 'treeRowBg' : '']" @mouseover='mouseOver' @mouseout='mouseOut' :style='styleObj'>
                <div class="pull-left pl-0 text-left" style="padding-top:3px!important">
                  <div v-if="!model.children" style="min-width:33px;"></div>
                  <button style="width: 23px; float: left;" v-if="!isClicked && model.children" :title="[buttonsTitle && buttonsTitle.expand ? buttonsTitle.expand : '']" @click="toggle" class="fa fa-chevron-down px-0 action btn-white"></button>
                  <button style="width: 23px; float: left;" v-if="isClicked && model.children" :title="[buttonsTitle && buttonsTitle.collapse ? buttonsTitle.collapse : '']" @click="toggle" class="fa fa-chevron-up px-0 action btn-white"></button>
                </div>

                <div :style='spaceLeft' class="col-xs-5 col-sm-7 col-md-6 col-lg-4" :class="[model.mainFather ? 'pl-0' : '']">
                  <b>{{model.number}}</b> &nbsp;&nbsp; {{model.description}}
                </div>

                <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2" v-html="$t('categoria.modal.labels.' + model.type)"></div>

                <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 text-right">{{formatInitialBalance(model.initialBalance)}}</div>

                <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 text-right">{{formatInitialBalanceDate(model.initialBalanceDate)}}</div>

                <div class="pull-right px-0 text-right col-xs-4 col-sm-2 col-md-2 col-lg-1-5" style="padding-top:3px!important">
                  <button v-if='showRemove && !model.children' style="width:23px; float:right;" @click="clickRemoveFunction(model.id)" :title="[model.emUso ? (buttonsTitle && buttonsTitle.removeBloq ? buttonsTitle.removeBloq : '') : (buttonsTitle && buttonsTitle.remove ? buttonsTitle.remove : '')]" class="fa fa-times action btn-white pr-0" :disabled='model.emUso'></button>
                  <button style="width:23px; float:right;" id="buttonEdit" @click="clickAction('buttonEdit')" :title="[buttonsTitle && buttonsTitle.edit ? buttonsTitle.edit : '']" class="fa fa-pencil action pr-0"></button>
                  <button style="width:23px; float:right;" id="buttonCreate" @click="clickAction('buttonCreate')" :title="[buttonsTitle && buttonsTitle.create ? buttonsTitle.create : '']" class="fa fa-plus action pr-0 mr-0"></button>
                </div>
              </div>

              <div class="clear"></div>

              <div v-show="open" v-if="isFolder">
                <item v-for="model in orderedNumbers" :spaceLeft='model.marginLeft' :clickFunction='clickFunction' :clickRemoveFunction='clickRemoveFunction' :showRemove='showRemove' :id='model.id' :father="model" :buttonsTitle="buttonsTitle" :model="model" :key='model.id' :currentHighlight='currentHighlight' :defaultText='defaultText' :hoverColor='hoverColor' :highlightColor='highlightColor'>
                </item>
              </div>
            </div>`,

  methods: {
    clickAction (idButton) {
      let isEdit = (idButton === 'buttonEdit')
      this.clickFunction(this.id, this.father, isEdit)
    },

    toggle () {
      if (this.isFolder) {
        this.open = !this.open
      }
      let rootTree = this.findRoot()

      this.isClicked = !this.isClicked

      if (this.currentHighlight) {
        if (nodeClicked !== this.model.id) {
          let treeParent = rootTree.$parent
          let nodeStack = [treeParent.$children[0]]
          while (nodeStack.length !== 0) {
            let item = nodeStack.shift()
            item.styleObj.background = 'white'
            if (item.$children && item.$children.length > 0) {
              nodeStack = nodeStack.concat(item.$children)
            }
          }
          this.styleObj.background = this.highlightColor ? this.highlightColor : '#99A9BF'
          nodeClicked = this.model.id
        }
      }
    },

    exchangeData (rootCom, from, to) {
      if (!to || !from || typeof to === 'string' || from.id === to.id) {
        return
      }

      from = JSON.parse(JSON.stringify(from))
      to = JSON.parse(JSON.stringify(to))
      // copy
      let treeData = JSON.parse(JSON.stringify(this.model))
      let nodeStack = [treeData]
      let status = 0

      try {
        while (!(status === 2)) {
          let item = nodeStack.shift()
          if (item.id === from.id) {
            item.id = to.id
            item.name = to.name
            if (to.children && to.children.length > 0) {
              item['children'] = to.children
            } else {
              item.children = []
            }
            status++
            continue
          }
          if (item.id === to.id) {
            item.id = from.id
            item.name = from.name
            if (from.children && from.children.length > 0) {
              item['children'] = from.children
            } else {
              item.children = []
            }
            status++
            continue
          }
          if (item.children && item.children.length > 0) {
            nodeStack = nodeStack.concat(item.children)
          }
        }
      } catch (e) {
        return
      }
      rootCom.assignData(treeData)
    },

    changeType () {
      if (this.currentHighlight) {
        nodeClicked = this.model.id
      }
      if (!this.isFolder) {
        this.$set(this.model, 'children', [])
        this.addChild()
        this.open = true
        this.isClicked = true
      }
    },

    mouseOver (e) {
      if (this.styleObj) {
        if ((this.styleObj.background !== '#99A9BF' || this.styleObj.background !== this.hightlightColor) && e.target.className === 'treeNodeText') {
          e.target.style.background = this.hoverColor ? this.hoverColor : '#E5E9F2'
        }
      }
    },

    mouseOut (e) {
      if (this.styleObj) {
        if ((this.styleObj.background !== '#99A9BF' || this.styleObj.background !== this.hightlightColor) && e.target.className === 'treeNodeText') {
          e.target.style.background = 'white'
        }
      }
    },

    findRoot () {
      let ok = false
      let that = this
      while (!ok) {
        if (!/VueDragTreeCom42/.test(that.$parent.$vnode.tag) || that.$parent.data) {
          ok = true
          break
        }
        that = that.$parent
      }
      return that
    },

    addChild () {
      this.model.children.push({
        name: this.defaultText ? this.defaultText : 'New Node',
        id: id++
      })
    },

    removeChild (id) {
      let parentModelChildren = this.$parent.model.children
      for (let index in parentModelChildren) {
        if (parentModelChildren[index].id === id) {
          parentModelChildren = parentModelChildren.splice(index, 1)
          break
        }
      }
    },

    dragStart (e) {
      e.dataTransfer.effectAllowed = 'move'
      e.dataTransfer.setData('nottext', e.target.innerHTML)
      return true
    },

    dragEnd (e) {
      fromData = undefined
      toData = undefined
      fromParentModelChildren = undefined
    },

    dragOver (e) {
      e.preventDefault()
      return true
    },

    dragOverPlus (e) {
      e.preventDefault()
    },

    dragEnterPlus (e) {
    },

    dragEnter (e) {
      toData = this.model
      let rootTree = this.findRoot()
      rootTree.exchangeData(rootTree.$parent, fromData, toData)
    },

    dragLeave (e) {
      fromData = this.model
      fromParentModelChildren = this.$parent.model.children
      // e.target.style.background = '#7B1FA2'
    },

    drop (e) {
      // toData = this.model
      // e.target.style.background = '#7B1FA2'
    },

    dropPlus (e) {
      if (this.model.hasOwnProperty('children')) {
        this.model.children.push(fromData)
      } else {
        this.model.children = [fromData]
      }
      for (let i in fromParentModelChildren) {
        if (fromParentModelChildren[i].id === fromData.id) {
          fromParentModelChildren.splice(i, 1)
        }
      }
    },

    formatInitialBalanceDate (timestamp) {
      if (timestamp === null) {
        return timestamp
      }
      const date = new Date(timestamp)
      const day = String(date.getDate()).padStart(2, '0')
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const year = date.getFullYear()
      return `${day}/${month}/${year}`
    },

    formatInitialBalance (value) {
      if (value === null) {
        return value
      }
      return value % 1 !== 0 ? value.toLocaleString('pt-BR', { minimumFractionDigits: 2 }) : `${value.toLocaleString('pt-BR')},00`
    }
  },

  beforeCreate () {
    this.$options.components.item = require('./TreeviewCategories')
  }
}
</script>

<style>
.treeview {
  font-family: 'Inter', sans-serif;
}

.treeview.vue-drag-tree {
  border-left: solid 1px #cdcdcd;
  border-right: solid 1px #cdcdcd;
  border-bottom: solid 1px #cdcdcd;
}

.padding-left-children {
  padding-left: 35px;
}

button.buttons-actions-treeview {
  width:23px;
  float:right;
}

.no-button-chevron {
  width:32px;
  float:right;
  height:14px;
}

.treeRow {
  padding-top: 5px;
  padding-bottom: 5px;
  border-bottom: 1px solid #DFDFDF;
}

.treeRowBg {
  background: #f3f8fe!important;
  font-weight: bold;
  border: none;
}

.treeRow .btn-white {
  color: #1c3b60;
}

.treeview.vue-drag-tree > div > .treeview > .treeRow {
  background: #f6f6f6;
  color: #414141;
}

.item {
  cursor: pointer;
}

.bold {
  font-weight: bold;
}

.treeNodeText {
  margin: 2px;
  padding: 0.2rem 0.5rem;
  width: fit-content;
  background: #F9FAFC;
  font-size: 18px;
  color: #324057;
}

.treeMargin {
  margin-left: 0px;
}

.changeTree {
  width: 1rem;
  color: #324057;
}

.vue-drag-node-icon {
  display: inline-block;
  width: 0;
  height: 0;
  padding-right: 3px;
  border-left: 6px solid black;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-right: 0 solid yellow;
  transition: transform .3s ease-in-out;
}

.nodeClicked {
  transform: rotate(90deg);
}

.col-lg-1-5 {
  width: 12.5%;
}
</style>



// WEBPACK FOOTER //
// TreeviewCategories.vue?edc01a42